import {AnchorProperties} from '../../anchor-properties.js'
import BoltAndNut from '../../models/bolt-and-nut.js'
import { parseLength, parsePressure } from '../../utils/units.js'


class BoltAndNutDialogComponent extends HTMLElement {

  boltType = 'threaded-rod'
  nutType = 'Square'
  boltDiameterLabel = '1/2"'
  embedDepth = '6'
  tensileStrength = '58.0'
  hookLength = '3'
  groutPads = false
  weldedToBasePlate = false

  constructor() {
    super();
    document.addEventListener('project-loaded', async (event) => this.onProjectLoaded(event.detail.boltAndNut), true)
    this.addEventListener('show.bs.modal', this.configure)
  }

  /**
   * Create our view model and configure the view
   * @param {BoltAndNut} model
   * 
   */
  onProjectLoaded(model) {
    this.boltType = model.boltType
    this.nutType = model.nutType
    this.boltDiameterLabel = model.boltDiameterLabel
    this.embedDepth = `${model.embedDepth}`
    this.tensileStrength = `${model.tensileStrength}`
    this.hookLength = `${model.hookLength}`
    this.groutPads = model.groutPads
    this.weldedToBasePlate = model.weldedToBasePlate
    //this.configure()
    //this.publishUpdate() 
  }

  publishUpdate() {
    const event = new CustomEvent('bolt-and-nut-dialog-update', { detail: this });
    this.dispatchEvent(event)
  }

  onBoltTypeClick(boltType) {
    this.boltType = boltType
    this.configure()
    this.publishUpdate()
  }

  onNutTypeClick(nutType) {
    this.nutType=nutType
    this.configureBoltSizeRadios()
    this.publishUpdate()
  }

  onBoltSizeClick(boltDiameterLabel) {
    this.boltDiameterLabel = boltDiameterLabel
    this.publishUpdate()
  }

  onTensileStrengthBlur() {
    const value = parsePressure(document.getElementById("tensile-strength-input").value)
    if(isNaN(value) || value <= 0) {
      document.getElementById('tensile-strength-validation').classList.remove('d-none')
      return
    }
    document.getElementById('tensile-strength-validation').classList.add('d-none') 
    this.tensileStrength = document.getElementById("tensile-strength-input").value
    this.publishUpdate()
  }

  onEmbedDepthBlur() {
    const value = parseLength(document.getElementById("embed-depth-input").value)
    if(isNaN(value) || value <= 0) {
      document.getElementById('embed-depth-validation').classList.remove('d-none')
      return
    }
    document.getElementById('embed-depth-validation').classList.add('d-none') 
    this.embedDepth = document.getElementById("embed-depth-input").value
    this.publishUpdate()
  }

  onHookLengthBlur() {
    const value = parseLength(document.getElementById("hook-length-input").value)
    if(isNaN(value) || value <= 0) {
      document.getElementById('hook-length-validation').classList.remove('d-none')
      return
    }
    document.getElementById('hook-length-validation').classList.add('d-none') 
    this.hookLength = document.getElementById("hooke-length-input").value
    this.publishUpdate()
  }

  onGroupPadsClick() {
    this.groutPads = document.getElementById("grout-pads").checked 
    this.publishUpdate()
  }

  onWeledToBasePlateClick() {
    this.weldedToBasePlate = document.getElementById("anchors-welded").checked 
    this.publishUpdate()
  }

  configure() {
    this.configureBoltTypeRadios()
    this.configureNutTypeRadios()
    this.configureBoltSizeRadios()
    document.getElementById("tensile-strength-input").value = this.tensileStrength
    document.getElementById("embed-depth-input").value = this.embedDepth
    document.getElementById("grout-pads").checked = this.groutPads
    document.getElementById("anchors-welded").checked = this.weldedToBasePlate
  }

  get boltTypeStr() {
    return this.boltType.replace('-', ' ').replace(/(^\w|\s\w)/g, m => m.toUpperCase())
  }

  get anchorProperties() {
    return AnchorProperties[this.boltType].find(element => element.label === this.boltDiameterLabel)
  }

  get availableNutTypes() {
    if(this.boltType !== 'threaded-rod' && this.boltType !== 'headed-bolt') {
      return []
    }
    return this.boltType === 'threaded-rod' ? 
    ['Square', 'Heavy Square', 'Hex', 'Heavy Hex'] :
    ['Square', 'Hex', 'Heavy Hex'] 
  }

  get availableBoltSizes() {
    let nutTypeKey = this.boltType === 'headed-stud' ? 'Abrg' : `Abrg ${this.nutType}`
    let properties = AnchorProperties[this.boltType]
    return properties.filter((property) => {
      return property[nutTypeKey] > 0
    }).map((property) => property.label)
  }

  configureBoltTypeRadios() {
    Object.keys(AnchorProperties).forEach((id) => {
      document.getElementById(id).checked = this.boltType === id
    })
  }

  configureNutTypeRadios() {
    let str = '<div><strong>2. Select a Nut Type</strong></div>'
    switch (this.boltType) {
      case 'threaded-rod':
      case 'headed-bolt':
        str += '<div class="btn-group btn-group-sm" id="nut-type-radio-group" role="group" style="margin:10px 0px 10px 0px;">'
        this.availableNutTypes.forEach((nutType) => {
          let id = `${nutType.toLowerCase().replaceAll(' ', '-')}-nut`
          str += `<input type="radio" class="btn-check" name="nut-type-radio" id=${id} autocomplete="off" ${this.nutType === nutType ? "checked" : ""}>`
          str += `<label class="btn btn-outline-secondary" for="${id}">${nutType}</label>`
        })
        str += '</div>'
        break
      case 'headed-stud':
        str = '<div style="margin-bottom:10px;"><strong class="text-muted">2. Headed Stud (no nuts)</strong><div>'
        break
      case 'hooked-bolt':
        str = '<div><strong>2. Specify Hook Length</strong><div>'
        str += '<table class="table"><tr><td>Hook Length (in)</td>'
        str += `<td><input style="width:75px;" id="hook-length-input" type="text" name="hook-length-input" class="length-validator text-center" value="${this.hookLength}"/>`
        str += '<div  style="width:200px;" id="hook-length-validation" class="alert alert-danger d-none">Please enter a valid length. e.g. 5 or 5"</div></td></tr></table>'
        break
    }
    document.getElementById("nut-type-selector").innerHTML = str

    if (this.boltType === 'threaded-rod' || this.boltType === 'headed-bolt') {
      let radios = document.getElementById('nut-type-radio-group').getElementsByTagName('input');
      for (var i = 0; i < radios.length; i++) {
        let selector = 'label[for=' + radios[i].id + ']';
        const labelStr = document.querySelector(selector).innerHTML;
        radios[i].onclick = ( () => this.onNutTypeClick(labelStr) ).bind(this)
      }
    }

    if(this.boltType === 'hooked-bolt') {
      document.getElementById('hook-length-input').onblur = (() => this.onHookLengthBlur())
    }
  }

  configureBoltSizeRadios() {
    let str = ('headed-stud' === this.boltType) ?
      "<div><strong>3. Select a Stud Size</strong></div>" :
      "<div><strong>3. Select a Bolt Size</strong></div>"

    str += '<div class="btn-group btn-group-sm" id="bolt-size-radio-group" role="group" style="margin:10px 0px 10px 0px;">'

    let availableSizes = this.availableBoltSizes
    // if the current bolt size is not in available sizes, set it to the first element
    const found = availableSizes.find(size => size === this.boltDiameterLabel)
    if(!found) { this.boltDiameterLabel = availableSizes[0] }

    for(let i = 0; i < availableSizes.length; i++) {
      str += `<input type="radio" class="btn-check" name="bolt-size-radio" id="bolt-size-${i}" autocomplete="off" ${this.boltDiameterLabel === availableSizes[i] ? "checked" : ""}>`
      str += `<label class="btn btn-outline-secondary" for="bolt-size-${i}">${availableSizes[i]}</label>`
      if (i === 6) {
        str += '</div><div class="btn-group btn-group-sm" id="bolt-size-radio-group-2" role="group" style="margin:0px 0px 10px 0px;">'
      }
    }

    str += '</div>'

    document.getElementById('bolt-size-selector').innerHTML = str

    if (availableSizes.length > 0) {
      let radios = Array.from(document.getElementById('bolt-size-radio-group').getElementsByTagName('input'))
      if(availableSizes.length > 7) {
        radios = radios.concat(Array.from(document.getElementById('bolt-size-radio-group-2').getElementsByTagName('input')))
      }
      for (var i = 0; i < radios.length; i++) {
        let selector = 'label[for=' + radios[i].id + ']';
        const labelStr = document.querySelector(selector).innerHTML;
        radios[i].onclick = function () {
          this.onBoltSizeClick(labelStr)
        }.bind(this)
      }
    }
  }

  connectedCallback() {
    this.innerHTML = String.raw`
<div class="modal fade" id="modal-anchor-bolt-dialog" tabindex="-1" role="dialog" aria-labelledby="anchor-bolt-dialog"
  aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Select an Anchor Bolt</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <form id="anchor-bolt-form">
          <div><strong>1. Select a Bolt Type</strong></div>
          <div class="btn-group btn-group-sm" id="bolt-type-radio-group" role="group" style="margin:10px 0px 10px 0px;"
            aria-label="Bolt type toggle button group">
            <input type="radio" class="btn-check" name="bolt-type-radio" id="threaded-rod" autocomplete="off" checked>
            <label class="btn btn-outline-secondary" for="threaded-rod">Threaded Rod</label>

            <input type="radio" class="btn-check" name="bolt-type-radio" id="headed-bolt" autocomplete="off">
            <label class="btn btn-outline-secondary" for="headed-bolt">Headed Bolt</label>

            <input type="radio" class="btn-check" name="bolt-type-radio" id="headed-stud" autocomplete="off">
            <label class="btn btn-outline-secondary" for="headed-stud">Headed Stud</label>

            <input type="radio" class="btn-check" name="bolt-type-radio" id="hooked-bolt" autocomplete="off">
            <label class="btn btn-outline-secondary" for="hooked-bolt">Hooked Bolt</label>
          </div>

          <div id="nut-type-selector"><strong>2. Select a Nut Type</strong></div>

          <div id="bolt-size-selector"><strong>3. Select a Bolt Size</strong></div>

          <div><strong>4. Tensile Strength and Embedment</strong></div>
          <div style="margin:10px 0px 10px 0px;">
            <table class="table">
              <tr>
                <td>Tensile Strength (ksi)</td>
                <td>
                  <input style="width:100px;" id="tensile-strength-input" type="text" name="tensile-strength"
                    class="text-center" value="${this.tensileStrength}" />
                  <div  style="width:200px;" id="tensile-strength-validation" class="alert alert-danger d-none">
                    Please enter a valid tensile strength. e.g. 58 or 58 ksi
                  </div>
                </td>
              </tr>
              <tr>
                <td>Embed Depth (in)</td>
                <td>
                  <input style="width:100px;" id="embed-depth-input" type="text" name="embed-depth"
                  class="text-center" value="${this.embedDepth}" />
                  <div  style="width:200px;" id="embed-depth-validation" class="alert alert-danger d-none">
                    Please enter a valid depth. e.g. 5 or 5"
                  </div>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <label><input type="checkbox" value="" id="grout-pads"> Grout
                    Pads</label>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <label><input type="checkbox" value="" id="anchors-welded">
                    Welded To Base Plate</label>
                </td>
              </tr>
            </table>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>`

    var boltTypeRadios = document.getElementById('bolt-type-radio-group').getElementsByTagName('input');
    for (const radio of boltTypeRadios) {
      radio.onclick = function () {
        this.onBoltTypeClick(radio.id)
      }.bind(this)
    }

    document.getElementById('tensile-strength-input').onblur = (() => this.onTensileStrengthBlur())
    document.getElementById('embed-depth-input').onblur = (() => this.onEmbedDepthBlur())

    document.getElementById('grout-pads').onclick = (() => this.onGroupPadsClick())
    document.getElementById('anchors-welded').onclick = (() => this.onWeledToBasePlateClick())

    this.configure()
  }
}

customElements.define('bolt-and-nut-dialog-component', BoltAndNutDialogComponent)

